import { AbstractControl, ValidatorFn, UntypedFormGroup, ValidationErrors } from '@angular/forms';

// for use this Validation it's need names of formControls as password and confirmPassword

export class PasswordsMatchValidation {
  static MatchPassword(AC: AbstractControl) {
    const password = AC.get('password').value;
    const confirmPassword = AC.get('confirmPassword').value;

    const error = password === '' || password !== confirmPassword ? { MatchPassword: true } : null;

    AC.get('confirmPassword').setErrors(error);
  }

  static MatchPassword2: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
    const password = control.get('password');
    const confirmPassword = control.get('confirmPassword');

    return password && confirmPassword && password.value !== confirmPassword.value ? { notMatchPassword: true } : null;
  };
}
